module.exports = __webpack_public_path__ + "img/lc.8b2a1e96.svg";